export class NICEUserStates {

    agentId: number;
    agentStateId: string;
    agentStateName: string;
    businessUnitId: number;
    contactId: number;
    duration: string;
    isActive: boolean;
    isAcw: boolean;
    isOutbound: boolean;
    firstName: string;
    fromAddress: string;
    lastName: string;
    mediaName: string;
    mediaType: number;
    openContacts: number;
    outStateDescription: string;
    outStateId: number;
    skillId: number;
    skillName: string;
    startDate: string;
    stationId: number;
    stationPhoneNumber: string;
    teamId: number;
    teamName: string;
    toAddress: string;
    userName: string;
    name: string;

    constructor(jsonData?) {
        if (jsonData) {
            this.agentId = jsonData.agentId;
            this.agentStateId = jsonData.agentStateId;
            this.agentStateName = jsonData.agentStateName;
            this.businessUnitId = jsonData.businessUnitId;
            this.contactId = jsonData.contactId;
            this.isActive = jsonData.isActive;
            this.isAcw = jsonData.isAcw;
            this.isOutbound = jsonData.isOutbound;
            this.firstName = jsonData.firstName;
            this.fromAddress = jsonData.fromAddress;
            this.lastName = jsonData.lastName;
            this.mediaName = jsonData.mediaName;
            this.mediaType = jsonData.mediaType;
            this.openContacts = jsonData.openContacts;
            this.outStateDescription = jsonData.outStateDescription;
            this.outStateId = jsonData.outStateId;
            this.skillId = jsonData.skillId;
            this.skillName = jsonData.skillName;
            this.startDate = jsonData.startDate;
            this.stationId = jsonData.stationId;
            this.stationPhoneNumber = jsonData.stationPhoneNumber;
            this.teamId = jsonData.teamId;
            this.teamName = jsonData.teamName;
            this.toAddress = jsonData.toAddress;
            this.userName = jsonData.userName;
            if (!this.startDate) {
                const diff = (new Date().getTime() - new Date(this.startDate).getTime()) / 1000;
                const days = Math.abs(diff / (24 * 60 * 60));
                let remainder = diff - (days * 24 * 60 * 60);
                const hours = Math.abs(remainder / 60 * 60);
                remainder = remainder - (hours * 60 * 60);
                const minutes = Math.abs(remainder / 60);
                const seconds = remainder - (minutes * 60);
                this.duration = days + 'D:' + hours + 'H:' + minutes + 'M:' + seconds + 'S';
            } else {
                this.duration = null;
            }
            this.name = this.firstName + ' ' + this.lastName;
        }else{
            this.agentId = 0;
            this.agentStateId = '';
            this.agentStateName = '';
            this.teamId = 0;

        }
    }

// test
}
